import React from "react";
import MediaQuery from "theme/components/helpers/MediaQuery";
import Breakpoints from "theme/components/atoms/Breakpoints";

const withNumberOfProductsPerSlide = () => (BaseComponent) => (props) =>
  (
    <MediaQuery minWidth={Breakpoints.desktop}>
      {(isDesktop) => (
        <BaseComponent
          key={isDesktop ? "desktop" : "mobile"}
          {...props}
          numberOfProductsPerSlide={isDesktop ? 4 : 2}
        />
      )}
    </MediaQuery>
  );

export default withNumberOfProductsPerSlide;
